// extracted by mini-css-extract-plugin
export default {"root":"search_page_root__0d2Zi","wrapper":"search_page_wrapper__l+cPO","left":"search_page_left__54Sbf","right":"search_page_right__KT1ad"};